import { render, staticRenderFns } from "./account_add.vue?vue&type=template&id=7f90b0d0&"
import script from "./account_add.vue?vue&type=script&lang=ts&"
export * from "./account_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports